import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from "../base";
import { CreateObject } from "../item";
import { Family } from './family';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { FamilyType } from '../types';
import { PreselectType } from '../types';
import { ProductType } from '../types';

const _schema = {
    "name": "FAMILYPRODUCT",
    "fields": [
        { name: "status", type: "string", default: "AC" },
        { name: "family", type: "objid" },
        { name: "sort", type: "number" },
        { name: "preselect", type: "objid" },
        { name: "product", type: "objid" }
    ],
    relate: [
        { direction: ">", target: "FAMILY", by: "family", name: "family", reason: "family", child: false, class: FamilyType },
        { direction: ">", target: "PRESELECT", by: "preselect", name: "preselect", reason: "preselect", child: false, class: PreselectType },
        { direction: ">", target: "PRODUCT", by: "product", name: "product", reason: "product", child: false, class: ProductType }
    ]
} as const;

const _FamilyProductClass = CreateObject(_schema);
if (!_FamilyProductClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class FamilyProduct extends _FamilyProductClass { 
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): FamilyProduct {
        return this._Copy(store) as FamilyProduct;
    }

    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || !this.Commited){
            return;
        }

        if (relation === 'family' && related instanceof Family){
            if (related === this.family){
                related.AddProduct(this);
            }
        }
    }

    /****************************/
    /* CLASS MEMBERS            */
    /****************************/

    get status(): string | null {
        return this['__base__status'];
    }

    set status(value: string){
        if (this.status == 'DE'){
            return;     // cannot modify deleted items
        }

        if (this.status == value){
            return;
        }

        this['__base__status'] = value;
        if (this.family){
            if ((this.status == 'DE') && !this.Commited){
                this.family.DelProduct(this);
            }
            else {
                this.family.DoRefresh(this.table);
            }    
        }
    }

    /****************************/
    /* CUSTOM METHODS           */
    /****************************/

    get IsValid(): boolean {
        if (!this.product && !this.preselect){
            return false;
        }

        let _isvalid = (!!this.status && (this.status != 'DE'));
        
        if (_isvalid && this.product){
            _isvalid = this.product.IsValid || false;
        }

        if (_isvalid && this.preselect){
            _isvalid = this.preselect.IsValid || false;
        }

        return _isvalid;
    }    
}
